import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../../Context/AuthContext';

const useTruckStats = () => {
  const { token,user } = useContext(AuthContext);

  const fetchTruckStats = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/freight/freight-stats?state=${user.state}`, {
      method: 'GET',
      headers: {
        'Content-type': 'Application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch Trucks statistics');
    }
    return response.json();
  };

  return useQuery('truckStats', fetchTruckStats);
};

export default useTruckStats;
